import { render, staticRenderFns } from "./QuestQuestions.vue?vue&type=template&id=6fafc6ec&scoped=true&"
import script from "./QuestQuestions.ts?vue&type=script&lang=ts&"
export * from "./QuestQuestions.ts?vue&type=script&lang=ts&"
import style0 from "./QuestQuestions.scss?vue&type=style&index=0&id=6fafc6ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fafc6ec",
  null
  
)

export default component.exports